

import {
    ListChecks, FileText,
    History, Route
} from 'lucide-react';
import { QuickAction } from '../quick-actions';

export const campaignManagementOptions: QuickAction[] = [
    {
        icon: <ListChecks className="w-4 h-4" />,
        text: "Manage Campaigns",
        description: "View and manage all aspects of your campaigns including budgets and bids.",
        section: "campaign-management",
        href: "/dashboard/campaigns",
        newTabHref: "/dashboard/campaigns"
    },
    {
        icon: <Route className="w-4 h-4" />,
        text: "Rotations",
        description: "View available pixels to share with affiliate networks to fire back events to clickster.",
        href: "/dashboard/rotations",
        newTabHref: "/dashboard/rotations"
    },
    {
        icon: <FileText className="w-4 h-4" />,
        text: "Campaign Drafts",
        description: "Access your campaign drafts and view creation history.",
        section: "campaign-management",
        href: "/dashboard/drafts",
        newTabHref: "/dashboard/drafts"
    },
    {
        icon: <History className="w-4 h-4" />,
        text: "Activity Monitor",
        description: "Review users activity logs and changes made in Clickster ",
        href: "/dashboard/activity",
        newTabHref: "/dashboard/activity"
    }
];

export const handleCampaignManagementClick = (option: QuickAction, onClose: () => void) => {
    onClose();
}; 